export default __webpack_public_path__ + "static/media/pupil.05205035.png";